import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  batch, shallowEqual, useDispatch, useSelector
} from 'react-redux';

import Breadcrumbs from '../../../../layout/components/Breadcrumbs';
import Button from '../../../../components/Button/Button';
import ButtonTypes from '../../../../constants/buttonTypes';
import PermissionsGate from '../../../../components/PermissionsGate/PermissionsGate';
import { permissions } from '../../../../common/permissionGroup';
import { IconFileExport, IconPlus, IconSetting } from '../../../../assets/icon';
import { setApplicationState } from '../../../../actions/application/application';
import toggleArrayItem from '../../../../helpers/toggleArrayItem';
import TableSettingModal from '../../../../components/TableSettingModal/TableSettingModal';
import { coWarehouseTable } from '../../../../constants/coWarehouseTable';
import Text from '../../../../components/Text/Text';
import Badge from '../../../../components/Badge/Badge';
import WarehouseEditModal from '../../../../components/WarehouseEditModal/WarehouseEditModal';
import downloadFilesType from '../../../../constants/downloadFilesType';
import DownloadFileModal from '../../../../components/DownloadFileModal/DownloadFileModal';
import { setWarehouseFilter } from '../../../../actions/coilovers/warehouse/warehouseFilter';
import getWarehouse from '../../../../thunks/coilovers/warehouse/getWarehouse';

const subheaderClassName = 'flex items-center border-t border-[#eff2f5] dark:border-[#1b263b] px-[25px] h-full';
const breadcrumbsClassName = 'py-[5px]';
const titleClassName = 'text-text-second text-[13px] mr-[10px]';
const dividerClassName = 'w-[1px] bg-[#eff2f5] dark:bg-[#1b263b] mx-[17px]';
const buttonClassName = 'px-[13px] py-[8px] mr-[5px]';

const WarehouseSubheader = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [editModalVisibility, setEditModalVisibility] = useState(false);
  const [tableSettingModalVisible, setTableSettingModalVisible] = useState(false);
  const [downloadModalVisible, setDownloadModalVisible] = useState(false);

  const {
    application: { warehouseTableSetting },
    getWarehouse: { total },
    warehouseFilter: {
      needToOrder,
      needPartsToOrder,
      isOverstock
    },
  } = useSelector((state) => ({
    orderedPartsFilter: state?.orderedPartsFilter,
    application: state?.application,
    getWarehouse: state?.getWarehouse,
    warehouseFilter: state?.warehouseFilter,

  }), shallowEqual);

  const breadcrumbs = {
    pageTitle: 'Warehouse',
    history: [
      {
        title: 'Home',
        onClick: () => navigate('/')
      },
      {
        title: 'Coilovers',
      },
      {
        title: 'Warehouse',
      },
    ]
  };

  const onCreateNew = () => {
    batch(() => {
      setEditModalVisibility(true);
    });
  };

  const onToOrder = () => {
    batch(() => {
      dispatch(setWarehouseFilter({
        needToOrder: !needToOrder
      }));
      dispatch(getWarehouse());
    });
  };

  const onPartsToOrder = () => {
    batch(() => {
      dispatch(setWarehouseFilter({ needPartsToOrder: !needPartsToOrder }));
      dispatch(getWarehouse());
    });
  };

  const onOverstock = () => {
    batch(() => {
      dispatch(setWarehouseFilter({ isOverstock: isOverstock === 'yes' ? undefined : 'yes' }));
      dispatch(getWarehouse());
    });
  };

  return (
    <div className={subheaderClassName}>
      <div className="flex-1">
        <Breadcrumbs breadcrumbs={breadcrumbs} containerStyle={breadcrumbsClassName} />
      </div>
      <div className="flex flex-row justify-end">
        <div className="flex flex-row" />
        <div className="flex flex-row items-center">
          <Text text="Filtered:" textStyle={titleClassName} />
          <Badge
            text={`${total}${total >= 10000 ? '+' : ''}`}
            type={ButtonTypes.LIGHT_INFO}
          />
        </div>
        <div className={dividerClassName} />
        <div className="flex flex-row items-center">
          <Text text="Filter By" bold textStyle={titleClassName} />
          <Button
            text="To order"
            type={needToOrder ? ButtonTypes.PRIMARY : ButtonTypes.ACTIVE_LIGHT}
            containerStyle={buttonClassName}
            onClick={onToOrder}
          />
          <Button
            text="Parts To Order"
            type={needPartsToOrder ? ButtonTypes.PRIMARY : ButtonTypes.ACTIVE_LIGHT}
            containerStyle={buttonClassName}
            onClick={onPartsToOrder}
          />
          <Button
            text="Overstock"
            type={isOverstock === 'yes' ? ButtonTypes.PRIMARY : ButtonTypes.ACTIVE_LIGHT}
            containerStyle={buttonClassName}
            onClick={onOverstock}
          />
        </div>
        <div className={dividerClassName} />
        <PermissionsGate can={permissions.COW_CREATE}>
          <Button
            type={ButtonTypes.LIGHT_SUCCESS}
            icon={<IconPlus />}
            onClick={onCreateNew}
            containerStyle={buttonClassName}
          />
        </PermissionsGate>
        <Button
          type={ButtonTypes.LIGHT}
          icon={<IconFileExport />}
          containerStyle={buttonClassName}
          tooltip="Click to download"
          tooltipId="warehouseExportTable"
          onClick={() => setDownloadModalVisible(true)}
        />
        <Button
          type={ButtonTypes.LIGHT}
          icon={<IconSetting />}
          containerStyle={buttonClassName}
          tooltip="Table settings"
          tooltipId="warehouseTableSettings"
          onClick={() => setTableSettingModalVisible(true)}
        />
      </div>
      <TableSettingModal
        title="Warehouse Table Setting"
        visible={tableSettingModalVisible}
        toggleVisible={() => setTableSettingModalVisible(false)}
        list={coWarehouseTable}
        values={warehouseTableSetting}
        onSelect={(val) => dispatch(setApplicationState({
          warehouseTableSetting: toggleArrayItem(warehouseTableSetting, val)
        }))}
      />
      <WarehouseEditModal
        visible={editModalVisibility}
        toggleVisible={() => setEditModalVisibility(false)}
        item={{}}
      />
      <DownloadFileModal
        visible={downloadModalVisible}
        toggleVisible={() => setDownloadModalVisible(false)}
        type={downloadFilesType.MM_WAREHOUSE}
      />
    </div>
  );
};

WarehouseSubheader.propTypes = {};

WarehouseSubheader.defaultProps = {};

export default WarehouseSubheader;
